module.exports = __webpack_public_path__ + "img/07univr.4c6bcc98.png";